import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import i18n from '@/lang/i18n';
import { PERIPHERAL_EQUIPMENT_LIST } from '@/services/consts/vehicle'


export default /*@__PURE__*/_defineComponent({
  __name: 'PeripheralEquipmentCheckBox',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props

const modelValue = computed({
  get() {
    return convertSelectedItemsObjectToArray(props.modelValue);
  },
  set(value) {
    emit('update:modelValue', convertSelectedItemsArrayToObject(value));
  },
});

const convertSelectedItemsObjectToArray = (objectItems: Record<string, boolean>) => {
  let arrayItems = [] as string[]
  if (objectItems) {
    Object.keys(objectItems).forEach((key: string) => {
      if (objectItems[key] === true) {
        arrayItems.push(key)
      }
    })
  }

  return arrayItems
}

const convertSelectedItemsArrayToObject = (arrayItems: string[]) => {
  const objectItems = {
    enabledCameraFront: false,
    enabledCameraRear: false,
    enabledCameraInner: false,
    enabledCameraSide: false,
    enabledTdsensorCh1: false,
    enabledTdsensorCh2: false,
    enabledTdsensorCh3: false,
    enabledTdsensorCh4: false,
    enabledEtc: false,
  } as Record<string, boolean>

  arrayItems.forEach((item: string) => {
    objectItems[item] = true
  })

  return objectItems
}


return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    items: _unref(PERIPHERAL_EQUIPMENT_LIST),
    "item-title": "name",
    "item-value": "value",
    label: _unref(i18n).global.t('pages.vehicles.peripheralEquipment'),
    multiple: "",
    chips: ""
  }, null, 8, ["modelValue", "items", "label"]))
}
}

})